import { useNavigate } from 'react-router-dom';
import emailjs from "emailjs-com";

export const useCustomNavigation = () => {
  const navigate = useNavigate();

  const handleNavigation = (isRouterLink: boolean, link: string) => {
    if (typeof link !== 'string') return;
    if ((link === '') && !isRouterLink) return;

    if (isRouterLink) {
      navigate(link);  // For internal navigation
    } else {
      window.open(link, '_blank');  // For external link navigation
    }
  };

  return handleNavigation;
};

export const sendEmail = (data: any) => {
  const templateParams = {
    to_name: "",
    message: data, // Message content
    to_email: process.env.REACT_APP_TO_EMAIL || '', // Your email address
  };

  const SERVICE_ID = process.env.REACT_APP_SERVICE_ID || '';
  const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID || '';
  const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY || '';

  emailjs
  .send(
    SERVICE_ID, // Replace with your EmailJS Service ID
    TEMPLATE_ID, // Replace with your EmailJS Template ID
    templateParams,
    PUBLIC_KEY // Replace with your EmailJS Public Key
  )
  .then(
      (response) => {
      console.log("Email sent successfully!", response);
      alert("Email sent successfully!");
      },
      (error) => {
      console.error("Failed to send email:", error);
      alert("Failed to send email.");
      }
  );
};